export default __webpack_public_path__ + "static/media/ic_mini_tpbank.c94a9199.svg";